export default __webpack_public_path__ + "static/media/tree19.d2f1cb6a.png";